import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=7beb3a29&scoped=true&"
import script from "./certification.vue?vue&type=script&lang=js&"
export * from "./certification.vue?vue&type=script&lang=js&"
import style0 from "./certification.vue?vue&type=style&index=0&id=7beb3a29&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beb3a29",
  null
  
)

export default component.exports